// true for a click the browser turns into "open in new tab/window" on an <a href>
// (Ctrl/Cmd/Shift/Alt held, or not the main button). <router-link> leaves those to the browser,
// so any side effects of the click (closing a modal/menu, resetting state) should be skipped too.
export function isNewTabClick(e) {
    return !!e && !!(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button !== undefined && e.button !== 0));
}
